import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=ea918832&"
import script from "./Breadcrumb.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea918832')) {
      api.createRecord('ea918832', component.options)
    } else {
      api.reload('ea918832', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=ea918832&", function () {
      api.rerender('ea918832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/breadcrumb/Breadcrumb.vue"
export default component.exports